import WalletIcon from '@mui/icons-material/Wallet';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PhonelinkSetupIcon from '@mui/icons-material/PhonelinkSetup';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LiveHelpRoundedIcon from '@mui/icons-material/LiveHelpRounded';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { routePath } from '../RoutePath';

const navBtnList = [
    {
        label: 'Payor',
        i18n: 'navbar-payor',
        icon: <RecentActorsIcon />,
        route: routePath.relationships,
        className: '',
        userGroup: 'both',
    },
    {
        label: 'Dashboard',
        i18n: 'navbar-dashboard',
        icon: <DashboardIcon />,
        route: routePath.dashboard,
        className: '',
        userGroup: 'both',
    },
    {
        label: 'Batch Creation',
        i18n: 'navbar-batch-creation',
        key: 'batch_creation',
        icon: <WalletIcon />,
        route: routePath.walletPay,
        className: '',
        userGroup: 'Builder',
    },
    {
        label: 'Payment Method',
        i18n: 'navbar-payment-method',
        icon: <WalletIcon />,
        route: routePath.paymentMethods,
        className: '',
        userGroup: 'Supplier',
    },
    {
        label: 'Working Capital',
        i18n: 'navbar-working-capital',
        key: 'working_capital',
        icon: <AttachMoneyIcon />,
        route: routePath.workingCapital,
        className: '',
        userGroup: 'Supplier',
        // Working Capital offers are accepted/rejected on behalf of the whole
        // user group, so only usergroup admins may see or reach the feature.
        requiresUserGroupAdmin: true,
    },
    {
        label: 'Pending Payments',
        i18n: 'navbar-pending-payments',
        key: 'pending_payment',
        icon: <MonetizationOnIcon />,
        route: routePath.pendingPayments,
        className: '',
        userGroup: 'Builder',
    },
    {
        label: 'Payments',
        i18n: 'navbar-payments',
        icon: <AccountBalanceWalletIcon />,
        route: routePath.payments,
        className: '',
        userGroup: 'both',
    },
    {
        label: 'Support',
        i18n: 'navbar-support',
        icon: <HeadsetMicIcon />,
        route: routePath.support,
        className: '',
        userGroup: 'both',
    },
    {
        label: 'FAQ',
        i18n: 'navbar-faq',
        icon: <PhonelinkSetupIcon />,
        route: routePath.faq,
        className: '',
        userGroup: 'Builder',
    },
    {
        label: 'FAQ',
        i18n: 'navbar-faq',
        icon: <LiveHelpRoundedIcon />,
        route: routePath.faq,
        className: '',
        userGroup: 'Supplier',
    },
];

export default navBtnList;
